<main class="landing-shell tracking-otp-shell" [class.is-rtl]="preferences.direction() === 'rtl'">
  <app-landing-header />

  <div class="tracking-otp-content">
    <app-otp-verification
      [title]="preferences.t('otpVerification.title')"
      [description]="preferences.t('landing.tracking.otpDescription')"
      [submitLabel]="preferences.t('otpVerification.submit')"
      [resendLabel]="preferences.t('otpVerification.resend')"
      [notice]="preferences.t('otpVerification.notice')"
      [error]="otpError"
      [isSubmitting]="isSubmitting"
      [isResending]="isResending"
      [countdownSeconds]="otpCountdownSeconds"
      (verifyOtp)="verifyOtp($event)"
      (resendOtp)="resendOtp()"
    />
  </div>
</main>
